import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { HeroBadge } from '../sections/HeroBadge.jsx';
import { INK, FG_2, LINE, PURPLE, PRIMARY_TINT } from '../sections/theme.js';

const CASES = [
    { key: 1, img: '/images/home/inst-univ.jpg', headerBg: '#EFEAF7' },
    { key: 2, img: '/images/home/inst-biz.jpg', headerBg: '#E9F1FB' },
    { key: 3, img: '/images/home/inst-gov.jpg', headerBg: '#EEF1E9' },
];

export default function InstitutionCards() {
    const { t } = useTranslation();

    return (
        <Box component="section" sx={{ background: '#fff', pt: { xs: 3, md: 4 }, pb: { xs: 6, md: 9 } }}>
            <Container maxWidth="lg">
                <Box sx={{ textAlign: 'center', mb: 5 }}>
                    <HeroBadge label={t('home.cases.tag')} />
                    <Typography
                        component="h2"
                        sx={{
                            fontSize: { xs: '1.75rem', md: '2.125rem' },
                            fontWeight: 700,
                            lineHeight: 1.2,
                            letterSpacing: '-0.01em',
                            color: INK,
                            mb: 1.5,
                        }}
                    >
                        {t('home.cases.title')}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: '1.0625rem',
                            fontWeight: 400,
                            color: FG_2,
                            lineHeight: 1.55,
                            maxWidth: 640,
                            mx: 'auto',
                        }}
                    >
                        {t('home.cases.desc')}
                    </Typography>
                </Box>

                <Grid container spacing={3}>
                    {CASES.map((c) => {
                        const chips = t(`home.cases.items.${c.key}.chips`)
                            .split(',')
                            .map((chip) => chip.trim());
                        return (
                            <Grid key={c.key} size={{ xs: 12, md: 4 }}>
                                <Box
                                    sx={{
                                        background: '#fff',
                                        border: `1px solid ${LINE}`,
                                        borderRadius: '20px',
                                        overflow: 'hidden',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        height: '100%',
                                    }}
                                >
                                    <Box sx={{ background: c.headerBg, lineHeight: 0 }}>
                                        <Box
                                            component="img"
                                            src={c.img}
                                            alt={t(`home.cases.items.${c.key}.title`)}
                                            loading="lazy"
                                            sx={{
                                                width: '100%',
                                                aspectRatio: '800 / 423',
                                                objectFit: 'cover',
                                                display: 'block',
                                            }}
                                        />
                                    </Box>
                                    <Box sx={{ p: '28px 32px 32px' }}>
                                        <Typography
                                            component="h3"
                                            sx={{ fontSize: '1.25rem', fontWeight: 700, color: INK, mb: 1.25 }}
                                        >
                                            {t(`home.cases.items.${c.key}.title`)}
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontSize: '0.9375rem',
                                                fontWeight: 400,
                                                lineHeight: 1.55,
                                                color: FG_2,
                                                mb: 2.25,
                                            }}
                                        >
                                            {t(`home.cases.items.${c.key}.desc`)}
                                        </Typography>
                                        <Stack
                                            direction="row"
                                            sx={{
                                                flexWrap: 'wrap',
                                                gap: 1,
                                            }}
                                        >
                                            {chips.map((chip) => (
                                                <Box
                                                    key={chip}
                                                    sx={{
                                                        fontSize: '0.75rem',
                                                        fontWeight: 600,
                                                        color: PURPLE,
                                                        background: PRIMARY_TINT,
                                                        px: '11px',
                                                        py: '5px',
                                                        borderRadius: '4px',
                                                    }}
                                                >
                                                    {chip}
                                                </Box>
                                            ))}
                                        </Stack>
                                    </Box>
                                </Box>
                            </Grid>
                        );
                    })}
                </Grid>
            </Container>
        </Box>
    );
}
